export default __webpack_public_path__ + "static/media/ID_SCHOOL_principal VLADOVSKY.40005069.jpg";